import { LinearProgress, Checkbox } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder, faEraser } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useState, useContext } from 'react';
import { formatDrive } from '../../apis/agent';
import AuthContext from '../../AuthContext';
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { getCompanyDevices, editLastLogin  ,requestOperation,checkValid} from '../../apis/axios';
import ConfirmDialog from '../common/ConfirmationModal'; // Import ConfirmationModal as ConfirmDialog

export default function DriveItem({ name, label, used, total, status, uuid, sys_uuid, device_id,disabled ,licence_id }) {
  const percentage = Math.round((used / total) * 100);
  const navigate = useNavigate();
  const auth = useContext(AuthContext);
  const [openRequest,setOpenRequest]=useState(false)
  const [isWiping, setIsWiping] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info"); // "error" | "success" | "warning"
  const [wipeStatus, setWipeStatus] = useState(null);
  const [openWipeConfirm, setOpenWipeConfirm] = useState(false); // State for confirmation modal
  const statusStyles = {
    Healthy: { backgroundColor: '#B8F2CE', color: '#128643' },
    Warning: { backgroundColor: '#FAD6AC', color: '#E56D00' },
    Critical: { backgroundColor: '#FCEDEC', color: '#E74C3C' },
  };
     const checkLicence = async () => {
    try {
      const res = await checkValid({ licence_id }); // your API call

      if (res.data.status === "limit_exceeded") {
        setSnackbarMsg("Licence limit exceeded");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      } else {
        setOpenWipeConfirm(true)
      }
    } catch (error) {
      console.error(error);
      setSnackbarMsg(error?.response?.data?.error || "Something went wrong");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const statusStyle = statusStyles[status] || { backgroundColor: '#E0E0E0', color: '#000000' };
  if (!auth.isLoggedIn || !auth.user) {
    return (
      <div className="border rounded-xl p-4 flex flex-col gap-3 shadow-sm w-full" style={{ fontFamily: 'Nunito Sans, sans-serif' }}>
        <div style={{ textAlign: 'center', color: '#E74C3C' }}>
          User not logged in. Please log in to access drive actions.
        </div>
      </div>
    );
    
  }

 
  const checkDeviceStatus = async () => {
    try {
      const companyId = auth.admin || '';
      if (!companyId) {
        throw new Error('companyId is empty or undefined.');
      }
      if (!uuid) {
        throw new Error('uuid is empty or undefined.');
      }

      // console.log('Sending getCompanyDevices request:', { company_id: companyId });
      const deviceResponse = await getCompanyDevices({ company_id: companyId });
      // console.log('Received getCompanyDevices response:', deviceResponse.data);

      if (deviceResponse && Array.isArray(deviceResponse.data)) {
        const device = deviceResponse.data.find(dev => dev.uuid === uuid);
        // console.log('Found device in getCompanyDevices:', device);

        if (!device) {
          throw new Error('Device not found.');
        }
        if (!device.id) {
          throw new Error('Device found but id is missing.');
        }

        const payload = {
          id: device_id,
          uuid: uuid,
        };
        // console.log('Sending editLastLogin request:', payload);
        const statusResponse = await editLastLogin(payload);
        // console.log('Received editLastLogin response:', statusResponse.data);

        const isActive = statusResponse.data.isActive === 1;
        // console.log('Device isActive status:', isActive);

        return { isActive, deviceId: device_id };
      } else {
        throw new Error('Invalid response from getCompanyDevices.');
      }
    } catch (err) {
      // console.error('Error in checkDeviceStatus:', err.message);
      setWipeStatus({ type: 'error', message: 'Failed to verify device status. Please ensure the device is registered and try again.' });
      return { isActive: false, deviceId: null };
    }
  };

  const handleViewFiles = () => {
    const explorerParams = { drive: name, uuid, sys_uuid, device_id ,disabled ,licence_id:licence_id};
    localStorage.setItem('fileExplorerParams', JSON.stringify(explorerParams));
    navigate('/file-explorer', { state: explorerParams });
  };

  const initiateWipeDrive = () => {
    setOpenWipeConfirm(true); // Show the confirmation modal
  };

  const handleConfirmWipe = async () => {
    setOpenWipeConfirm(false); // Close the modal immediately upon confirm
    setIsWiping(true);
    setWipeStatus(null);
    try {
      let driveLetter = name.replace(/\/$/, '').toUpperCase();
      if (!driveLetter.endsWith(':')) {
        driveLetter += ':';
      }
      driveLetter = driveLetter.replace(/\\/g, '\\\\').replace(/:/g, ':\\\\');

      const { isActive } = await checkDeviceStatus();
      //console.log(isActive )
      if (!device_id) {
        throw new Error('Device ID not found. Cannot proceed with operation.');
      }
//console.log(device_id)
      if (isActive) {
        const operationData = {
          "device_id": parseInt(device_id),
          "user_id": parseInt(auth.user),
          "type": "format_drive",
          "json": {
            "path": driveLetter
          }
        };
        const operationResponse = await requestOperation(operationData);

        const operationLogId = operationResponse.data.log_id;
setOpenRequest(true)
        if (!operationLogId) {
          throw new Error("No log_id returned from addOperation");
        }

        const requestData = {
          log_id: operationLogId,
          drive_letter: driveLetter.replace(/\\\\/g, ''),
        };
        const formatResponse = await formatDrive(uuid, driveLetter.replace(/\\\\/g, ''), operationLogId, sys_uuid);

        setWipeStatus({ type: 'success', message: `Drive ${name} wiped successfully.` });
      } else {
        const userId = auth.user;
        if (!userId) {
          throw new Error('User ID not found. Please log in again.');
        }

        const operationData = {
          "device_id": parseInt(device_id),
          "user_id": parseInt(userId),
          "type": "format_drive",
          "json": {
            "path": driveLetter
          }
        };
        const queueResponse = await requestOperation(operationData);
        setOpenRequest(true)

        const queueLogId = queueResponse.data.log_id;

        if (!queueLogId) {
          throw new Error("No log_id returned from addQueueOperation");
        }

        setWipeStatus({ type: 'info', message: 'Device is offline. Wipe operation has been queued.' });
      }
    } catch (error) {
      setWipeStatus({ type: 'error', message: `Failed to wipe drive ${name}: ${error.message}` });
    } finally {
      setIsWiping(false);
    }
  };

  const handleCancelWipe = () => {
    setOpenWipeConfirm(false); // Close the modal on cancel
  };

  return (
    <div className="border rounded-xl p-4 flex flex-col gap-3 shadow-sm w-full relative">
      {isWiping && (
        <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-50 z-10">
          <div className="spinner"></div>
        </div>
      )}
      <div className={`flex flex-col sm:flex-row justify-between items-start sm:items-start gap-2 ${isWiping ? 'opacity-50 pointer-events-none' : ''}`}>
        <div className="flex items-start gap-2">
          <Checkbox
            sx={{
              width: 20,
              height: 20,
              marginTop: '8px',
              '& .MuiSvgIcon-root': {
                fontSize: 20,
              },
              '&:not(.Mui-checked)': {
                color: '#202224',
              },
              '&.Mui-checked': {
                color: '#FF7A00',
              },
            }}
            disabled={isWiping|| disabled}
          />
          <div>
            <div
              style={{
                fontFamily: 'Nunito Sans, sans-serif',
                fontSize: '24px',
                fontWeight: 700,
                color: '#202224',
              }}
            >
              {name}
            </div>
            <div className="flex flex-col md:flex-row lg:flex-row xl:flex-row items-center gap-5">
              <div
                style={{
                  fontFamily: 'Nunito Sans, sans-serif',
                  fontSize: '14px',
                  fontWeight: 600,
                  color: '#595C60',
                }}
              >
                {label}
              </div>
              <span
                style={{
                  ...statusStyle,
                  width: '94px',
                  height: '28px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '9999px',
                  fontSize: '14px',
                  fontWeight: 600,
                  fontFamily: 'Nunito Sans, sans-serif',
                }}
              >
                {status}
              </span>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-4 mt-2">
          <button
            className="text-orange-500 text-sm hover:underline"
            onClick={handleViewFiles}
            disabled={isWiping ||disabled}
          >
            <FontAwesomeIcon icon={faFolder} className="mr-1" />
            View Files
          </button>
          <button
            className="text-red-500 text-sm hover:underline"
            onClick={initiateWipeDrive} // Update to show confirmation modal
            disabled={isWiping || disabled}
          >
            <FontAwesomeIcon icon={faEraser} className="mr-1" />
            Wipe Drive
          </button>
        </div>
      </div>

      <div
        style={{
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '14px',
          fontWeight: 600,
          color: '#595C60',
        }}
        className={isWiping ? 'opacity-50' : ''}
      >
        Used Space: {used}GB of {total}GB
      </div>
      <LinearProgress
        variant="determinate"
        value={percentage}
        color={percentage < 50 ? 'success' : percentage < 80 ? 'warning' : 'error'}
        sx={{
          height: 6,
          borderRadius: 4,
          '& .MuiLinearProgress-bar': {
            borderRadius: 4,
          },
        }}
        className={isWiping ? 'opacity-50' : ''}
      />
      {wipeStatus && (
        <div
          style={{
            fontFamily: 'Nunito Sans, sans-serif',
            fontSize: '14px',
            fontWeight: 600,
            color: wipeStatus.type === 'success' ? '#128643' : wipeStatus.type === 'info' ? '#FF7A00' : '#E74C3C',
            marginTop: '8px',
            textAlign: 'center',
          }}
        >
          {wipeStatus.message}
        </div>
      )}

      {/* Add Confirmation Modal for Wipe Drive */}
      <ConfirmDialog
        open={openWipeConfirm}
        title="Confirm Wipe Drive"
        message={`Are you sure you want to wipe drive ${name}? This action will permanently erase all data and cannot be undone.`}
        onConfirm={handleConfirmWipe}
        onCancel={handleCancelWipe}
        confirmText="Wipe"
        cancelText="Cancel"
        confirmButtonColor="#E74C3C"
      />
             <ConfirmDialog
        open={openRequest}
        title="Request for Deletion"
        message={`Deletion Request is sent to Admin , You Will Recieve OTP Shortly`}
        onConfirm={()=>setOpenRequest(false)}
        onCancel={()=>setOpenRequest(false)}
        confirmText="OK"
        cancelText="Cancel"
        confirmButtonColor="#FF7A00"
      />

<Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMsg}
        </Alert>
      </Snackbar>

      <style>
        {`
          .spinner {
            width: 24px;
            height: 24px;
            border: 4px solid #FF7A00;
            border-top: 4px solid transparent;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}